import { authHeader } from '../../_helpers';
import axios from 'axios';

export const orgImgUploadService = {
    postImgService,
    removeImgUploadService
}

axios.defaults.headers.common = authHeader();

function postImgService(data) {
    const formData = new FormData;
    formData.append('organisation_image', data.file)
 
    return axios.post(`/users/organisation/image/upload/${data.id}/`, formData)
            .then(response => response)
            .catch(error => Promise.reject(error.response || error.message))
}

function removeImgUploadService(data) {
    return axios.post(`/users/organisation/image/delete/`, data)
            .then(response => response)
}


// WEBPACK FOOTER //
// ./src/_services/organisation/orgImgUpload.service.js